<template>
    <div class="action-table">
        <v-client-table
            :data="tableData"
            :columns="columns"
            :options="options"
            ref="table"
        >
            <colored-letter-square
                slot="cls_column"
                slot-scope="props"
                :name="props.row.title"
                :length="2"
            >
            </colored-letter-square>
            <client-course-actions
                slot="actions"
                slot-scope="props"
                :data="props.row"
                :index="props.index"
                :clientId="client.id"
            >
            </client-course-actions>
        </v-client-table>
    </div>
</template>

<script>
import {EventBus} from '../eventbus';

export default {
    props: {
        client: Object,
    },
    data() {
        return {
            tableData: [],
            columns: ['cls_column', 'title', 'variation_name', 'actions'],
            options: {
                headings: {
                    cls_column: '',
                    title: this.trans('course_variations.label.title'),
                    variation_name: this.trans(
                        'course_variations.label.variation_name'
                    ),
                    actions: this.trans('vuetables.label.actions'),
                },

                texts: {
                    count: this.trans('vuetables.label.countText'),
                    filter: this.trans('vuetables.label.filter'),
                    noResults: this.trans('vuetables.label.loading'),
                    filterPlaceholder: this.trans('vuetables.label.search')
                },

                sortable: ['title', 'variation_name'],
            },
        };
    },

    created() {
        this.fetch();
    },

    methods: {
        fetch() {
            axios.get(this.route('tenantapi.clients.courses.index', {client: this.client.id}))
                .then(this.refresh);
        },

        refresh({data}) {
            // fetch the data
            this.tableData = data.data;

            // change the error text from 'now loding' to 'no match'
            this.options.texts.noResults = this.trans(
                'vuetables.label.noResults'
            );
        },
    },

    mounted() {
        EventBus.$on('onDelete', deleteId => {
            var index = this.tableData.findIndex(data => data.id == deleteId);
            this.tableData.splice(index, 1);
        });

        var filter = this.debounce(query => {
            this.$refs.table.setFilter(query);
        }, 500);

        EventBus.$on('onFilter', query => {
            filter(query);
        });
    },
};
</script>
